import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import API from "../../utils/axios";
// import { useDispatch } from "react-redux";
import {
  Box,
  IconButton,
  Typography,
  Paper,
  Button,
  Switch,
  Grid
} from "@material-ui/core";
import MagicIcon from "../icons/MagicIcon";
// import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  setProject,
  setSelectedRoutes,
  silentlyGetSolution,
  setCurrentWindow,
  clearChangedVehicles,
  deleteAllStops,
  postOptimize,
  reoptimizeRoutes
  // editModeToggle
} from "../../store/actions/project";
import ConfirmDialog from "../dialogs/ConfirmDialog";
import { setLoadingRoutesList } from "../../store/actions/loading";
import { setProjectTabValue } from "../../store/actions/common";
import { setExtendableType, setExtendableId } from "../../store/actions/edit";
import Fab from "@material-ui/core/Fab";
// import PrintRoutes from "./PrintRoutes";
import {
  remCalc,
  isEmptyObj,
  // exportToXlsx,
  // generateStopDataForXLSX,
  // getDateValue,
  // distanceStr,
  capitalize
} from "../../utils/helpers";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";

import Grow from "@material-ui/core/Grow";
import DateFnsUtils from "@date-io/date-fns";
import PublishSettings from "./PublishSettings";
// import MoreOptionsMenu from "./MoreOptionsMenu";
// import SelectedRouteActions from "./SelectedRouteActions";
// import ShareProject from "../dialogs/ShareProject";
import { bottomBarPath } from "../../utils/clipPath";
import UnsavedChangesDialog from "../dialogs/UnsavedChangesDialog";
import { useSnackbar } from "notistack";
import { client } from "../map/DriverMarkers";
import OptimizedTooltip from "../common/OptimizedTooltip";
import { headerRow } from "../data/constants";
import { store } from "../..";
// import PrintLabels from "./PrintLabels";
// import AppSettingsIcon from "../icons/AppSettingsIcon";
// import EditIcon from "@material-ui/icons/Edit";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
// import PublishIcon from "@material-ui/icons/Publish";

import mixpanelWrapper from "../../utils/mixpanel";
import useProductTour, {
  PRODUCT_TOUR_STEP_IDS
} from "../../states/tour/tours/product";

import checkIcon from "../../assets/images/icons/check-icon.svg";
import minusIcon from "../../assets/images/icons/minus-icon.svg";

import notAllowedCursor from "../../assets/images/cursors/not-allowed.svg";

const dateFns = new DateFnsUtils();

const useStyles = makeStyles(theme => ({
  root: {
    filter: `drop-shadow(0 0 2px rgba(0, 0, 0, 0.14))`
  },
  fabWrapper: {
    position: "absolute",
    top: -28
  },
  fab: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: "#fff",
    boxShadow: `0px 1px 10px rgba(0, 0, 0, 0.2),
       0px 4px 5px rgba(0, 0, 0, 0.12),
       0px 2px 4px rgba(0, 0, 0, 0.14)`,
    "&.Mui-disabled": {
      boxShadow: `0px 1px 10px rgba(0, 0, 0, 0.2),
       0px 4px 5px rgba(0, 0, 0, 0.12),
       0px 2px 4px rgba(0, 0, 0, 0.14)`,
      backgroundColor: "#fff",
      "& svg": { color: "#C4C4C4" }
    },
    "&:hover": {
      backgroundColor: "#EEE"
    }
  },
  actionBtn: {
    minWidth: 0,
    height: 32,
    width: 32,
    borderRadius: theme.variables.borderRadius,
    marginRight: theme.spacing(1),

    "&:hover svg": {
      color: theme.variables.rootColor
    },
    "&.Mui-disabled": {
      opacity: 0.38
    }
  },
  paper: {
    borderRadius: theme.variables.borderRadius * (4 / 3),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  cutoutClipPath: {
    "-webkit-clip-path": bottomBarPath,
    clipPath: bottomBarPath
  },
  buttonIcon: {
    color: "inherit",
    marginRight: theme.spacing(1.25),
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
  buttonIconRight: {
    color: "inherit",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(-0.25),
    width: theme.spacing(2.5),
    height: theme.spacing(2.5)
  },
  btnGroup: {
    boxShadow: "none"
  },
  pointerEventsEnabled: {
    pointerEvents: "auto !important",
    "&:hover": {
      backgroundColor: theme.palette.primary.main + "!important"
    }
  },
  editProjectBtn: {
    color: "#606165",
    padding: theme.spacing(0.625, 2, 0.625, 1.5),
    borderColor: "#ddd",
    "&.Mui-disabled": {
      color: "#606165 !important"
    }
  },
  publishToggle: {
    minWidth: 24,
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),

    "& svg": {
      color: "#fff",
      transition: "background-color .2s, transform .2s"
    }
  },
  publishToggleOpen: {
    backgroundColor: "#8994FF",

    "& svg": {
      transform: "rotate(180deg)"
    }
  },
  // PublishPopper for driverConfig
  publishPopper: {
    top: "-234px !important",
    position: "absolute !important",
    left: "46px !important",
    zIndex: 1
  },
  publishedAndDriverConfigurationButtonsGroup: {
    marginRight: "24px"
  },
  publishPaper: {
    width: remCalc(384),
    border: "1px solid #EEE",
    borderRadius: 4,
    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16)"
  },
  menuItem: {
    minHeight: 40,

    "& svg, img": {
      marginRight: theme.spacing(3)
    }
  },
  btnLink: {
    minWidth: remCalc(50),
    height: remCalc(36),

    "&:last-of-type": {
      marginRight: theme.spacing(1)
    }
  },
  verticalDivider: {
    height: 24,
    alignSelf: "center",
    borderRight: theme.variables.border,
    width: 1
  },
  imgSvgIcon: {
    width: "1.5rem",
    height: "1.5rem"
  },
  // New
  wrapper: {
    position: "relative"
  },
  wrapperExpanded: {
    height: "fit-content"
  },
  optimizeBtn: {
    position: "absolute",
    top: 0,
    right: 32,
    height: 48,
    textTransform: "none",
    boxShadow: "none",
    "&.Mui-disabled": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      "&::after": {
        content: "''",
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        position: "absolute",
        zIndex: "5",
        cursor: `url(${notAllowedCursor}), not-allowed !important`,
        borderRadius: "50px",
        opacity: "0.62",
        pointerEvents: "all"
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      }
    }
  },
  reoptimizeBtn: {
    textTransform: "none",
    width: "auto",
    fontFamily: "Roboto",
    boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.16)",
    backgroundColor: "#fff",
    position: "absolute",
    right: "32px",
    zIndex: 1,
    bottom: "80px",
    padding: "12px 20px",
    height: "48px",
    borderRadius: "50px",
    color: theme.palette.primary.main,
    fontWeight: 500,
    "&.Mui-disabled": {
      backgroundColor: "#fff",
      color: theme.palette.primary.main,
      "&::after": {
        content: "''",
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        position: "absolute",
        borderRadius: "50px",
        opacity: "0.62",
        pointerEvents: "all",
        cursor: theme.cursors.notAllowed,
        boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.16)"
      },
      "&:hover": {
        backgroundColor: "white"
      }
    },
    "&:hover": {
      transition: "0.2s ease-out",
      backgroundColor: "#F4F4F4",
      color: theme.palette.primary.main
    }
  },
  reoptimizeBtnWithoutBottomBar: {
    top: "-81px"
  },
  publishBtn: {
    backgroundColor: theme.palette.primary.main,
    padding: "0.4rem 0.875rem 0.4rem 0.5rem",
    justifyContent: "space-around",
    alignItems: "center",
    textTransform: "none",
    paddingLeft: theme.spacing(2),
    color: "#fff",
    // 1.16+ we will change publish button and we need this styles for icons (CurrentButtonDesign is temporary)
    // "& > .MuiButton-label": {
    //   "& svg": {
    //     paddingRight: "0.815rem",
    //     color: "#fff"
    //   }
    // },
    "&:hover": {
      backgroundColor: "#0114CB"
    }
  },
  editModeSwitch: {
    color: "#4D4D50",
    padding: theme.spacing(0, 1.5),
    border: "1px solid #DBDCE1",
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    fontFamily: "Roboto"
  },
  editModeToggle: {
    "& .MuiSwitch-switchBase": {
      "& .MuiIconButton-label": {
        color: "gray"
      },
      "&.Mui-checked": {
        "& .MuiSwitch-thumb:before": {
          backgroundImage: `url(${checkIcon})`
        },
        "& > .MuiIconButton-label": {
          color: theme.palette.primary.main
        }
      },
      "& .MuiSwitch-thumb": {
        width: 20,
        height: 20,
        "&:before": {
          content: "''",
          position: "absolute",
          width: "100%",
          height: "100%",
          left: 0,
          top: 0,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url(${minusIcon})`
        }
      }
    }
  },
  bottomBarContainer: {
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.16)",
    padding: "0.75em 0",
    alignItems: "center",
    minHeight: 64
  },
  bottomBarLeftSide: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "1rem",
    marginLeft: theme.spacing(3)
  },
  driverAppConfiguration: {
    color: "white",
    padding: 0,
    margin: 0,
    backgroundColor: theme.palette.primary.main,
    minWidth: "24px !important",
    "& > .MuiButton-label": {
      "& > div": {
        margin: 0
      },
      "& button": {
        padding: 0,
        margin: 0
      },
      "& svg": {
        color: "#fff"
      }
    },
    "&:hover": {
      backgroundColor: "#0114CB"
    }
  },
  driverAppConfigurationInEditMode: {
    color: "white",
    padding: 0,
    margin: 0,
    backgroundColor: "#fff",
    minWidth: "24px !important",
    borderColor: "#DBDCE1",
    "& > .MuiButton-label": {
      "& > div": {
        margin: 0
      },
      "& button": {
        padding: 0,
        margin: 0
      },
      "& svg": {
        color: "#606165"
      }
    },
    "&:hover": {
      backgroundColor: "#fff"
    }
  }
}));

function BottomActions({
  project,
  solution,
  published,
  hasStops,
  stops,
  vehicles,
  // organisation,
  // billingDetails,
  selectedVehicles,
  // changedVehicles,
  currentWindow,
  setProjectTabValue,
  setCurrentWindow,
  selectedRoutes,
  setSelectedRoutes,
  clearChangedVehicles,
  setExtendableType,
  setExtendableId,
  setLoadingRoutesList,
  setProject,
  silentlyGetSolution,
  // deleteAllStops,
  postOptimize,
  reoptimizeRoutes,
  saveDisabled,
  settingsSaveDisabled,
  isPastProject,
  publishDisabled,
  distanceUnits,
  plan,
  // hasSelectedRouteStops,
  isOptimized,
  isEditMode,
  isProjectInitialLoading,
  isStopSearchMode,
  isStopSelectMode,
  isRoutesSearchMode,
  isProjectStarted,
  determinateLoading,
  showingRouteId,
  projectTabValue
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  // const [shareOpen, setShareOpen] = useState(false);
  const [changesDialog, setChangesDialog] = useState({
    visible: false,
    type: "",
    action: ""
  });

  const [confirmDialog, setConfirmDialog] = useState({
    visible: false,
    type: "",
    action: "",
    checked: false
  });

  const [reoptimizeDisabled, setReoptimizeDisabled] = useState(false);
  // const open = Boolean(anchorEl);

  // const printRef = useRef();
  // const labelsPrintRef = useRef();

  const [isPrinting, setPrinting] = useState(false);
  const [isPrintingLabel, setPrintingLabel] = useState(false);
  const productTour = useProductTour();

  useEffect(() => {
    setAnchorEl(null);
  }, [currentWindow]);

  useEffect(() => {
    if (!isPrintingLabel) {
      setLoadingRoutesList(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPrintingLabel]);

  useEffect(() => {
    const hasCreatedRoutes =
      !!solution && solution?.routes.some(route => route?.stops?.length > 2);
    if (hasCreatedRoutes && !isProjectInitialLoading) setProjectTabValue(1);
  }, [determinateLoading]);

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  let readyToPrint = useRef(false);
  useEffect(() => {
    if (isPrinting && !readyToPrint.current) {
      readyToPrint.current = true;
    } else if (readyToPrint.current) {
      readyToPrint.current = false;
    }
  }, [isPrinting]);

  let readyToPrintLabel = useRef(false);
  useEffect(() => {
    if (isPrintingLabel && !readyToPrintLabel.current) {
      readyToPrintLabel.current = true;
    } else if (readyToPrintLabel.current) {
      readyToPrintLabel.current = false;
    }
  }, [isPrintingLabel]);

  // Publish menu
  const [openPublish, setOpenPublish] = useState(false);
  const publishBtnRef = React.useRef();

  const handlePublishToggle = bool => {
    setOpenPublish(bool !== undefined ? bool : !openPublish);
  };

  const handlePublishClose = event => {
    if (publishBtnRef.current && publishBtnRef.current.contains(event.target)) {
      return;
    }

    setOpenPublish(false);
  };

  const unassignedRoutesCount = useMemo(
    () =>
      solution?.routes.filter(
        route =>
          route.driver === null &&
          route.selected &&
          !route.vehicle_id.includes("_") &&
          route.stops.length > 2
      ).length,
    [solution]
  );

  // const handleCsvDownload = (type = "stops") => {
  //   let data;
  //   const solution = store.getState().project.solution;
  //   const header = [...headerRow];
  //   if (type === "solution") {
  //     header.unshift("route", "vehicle", "driver", "stop", "planned_eta");
  //     isPastProject &&
  //       header.push(
  //         "project_name",
  //         "project_date",
  //         "route_started_at",
  //         "route_completed_at",
  //         "delivery_status",
  //         "delivered_at",
  //         "external_note",
  //         "internal_note",
  //         distanceUnits === "km"
  //           ? "planned_distance_km"
  //           : "planned_distance_miles"
  //       );
  //     data = [
  //       header,
  //       ...solution.routes.reduce((array, route) => {
  //         let count = 0;
  //         return [
  //           ...array,
  //           ...route.stops
  //             .filter(task => !["start", "end", "break"].includes(task.type))
  //             .reduce((array, row) => {
  //               count++;
  //               return [
  //                 ...array,
  //                 ...(!row.units || row.units.length === 0
  //                   ? [
  //                       generateStopDataForXLSX(row, 0, {
  //                         type,
  //                         isPastProject,
  //                         published,
  //                         route: route.index,
  //                         vehicle: route.vehicle_name,
  //                         driver: route.driver
  //                           ? `${route.driver.first_name} ${route.driver.last_name}`
  //                           : "",

  //                         stop: count,
  //                         project_name: project.name,
  //                         project_date: dateFns.format(
  //                           new Date(getDateValue(project.project_date)),
  //                           "dd-MM-yyyy"
  //                         ),
  //                         route_started_at: route.start_timestamp,
  //                         route_completed_at: route.end_timestamp,
  //                         planned_distance: distanceStr(
  //                           route.distances,
  //                           distanceUnits === "km",
  //                           true
  //                         )
  //                       })
  //                     ]
  //                   : row.units.map((unit, i) =>
  //                       generateStopDataForXLSX(row, i, {
  //                         type,
  //                         isPastProject,
  //                         published,
  //                         route: route.index,
  //                         vehicle: route.vehicle_name,
  //                         driver: route.driver
  //                           ? `${route.driver.first_name} ${route.driver.last_name}`
  //                           : "",

  //                         stop: count,
  //                         project_name: project.name,
  //                         project_date: dateFns.format(
  //                           new Date(getDateValue(project.project_date)),
  //                           "dd-MM-yyyy"
  //                         ),
  //                         route_started_at: route.start_timestamp,
  //                         route_completed_at: route.end_timestamp,
  //                         planned_distance: distanceStr(
  //                           route.distances,
  //                           distanceUnits === "km",
  //                           true
  //                         )
  //                       })
  //                     ))
  //               ];
  //             }, [])
  //         ];
  //       }, []),
  //       ...solution.unassigned.stops.reduce((array, row) => {
  //         return [
  //           ...array,
  //           ...(!row.units || row.units.length === 0
  //             ? [
  //                 generateStopDataForXLSX(row, 0, {
  //                   type,
  //                   isPastProject,
  //                   published,
  //                   route: "unscheduled",
  //                   vehicle: "",
  //                   driver: "",
  //                   stop: "",
  //                   project_name: project.name,
  //                   project_date: dateFns.format(
  //                     new Date(getDateValue(project.project_date)),
  //                     "dd-MM-yyyy"
  //                   ),
  //                   route_started_at: "",
  //                   route_completed_at: "",
  //                   planned_distance: ""
  //                 })
  //               ]
  //             : row.units.map((unit, i) =>
  //                 generateStopDataForXLSX(row, i, {
  //                   type,
  //                   isPastProject,
  //                   published,
  //                   route: "unscheduled",
  //                   vehicle: "",
  //                   driver: "",
  //                   stop: "",
  //                   project_name: project.name,
  //                   project_date: dateFns.format(
  //                     new Date(getDateValue(project.project_date)),
  //                     "dd-MM-yyyy"
  //                   ),
  //                   route_started_at: "",
  //                   route_completed_at: "",
  //                   planned_distance: ""
  //                 })
  //               ))
  //         ];
  //       }, [])
  //     ];
  //   } else if (selectedRoutes.length) {
  //     header.unshift("route", "vehicle", "driver", "stop", "eta");

  //     data = [
  //       header,
  //       ...solution.routes.reduce((array, route) => {
  //         let count = 0;
  //         return selectedRoutes.includes(route.id)
  //           ? [
  //               ...array,
  //               ...route.stops
  //                 .filter(
  //                   task => !["start", "end", "break"].includes(task.type)
  //                 )
  //                 .reduce((array, row) => {
  //                   count++;

  //                   return [
  //                     ...array,
  //                     ...(!row.units || row.units.length === 0
  //                       ? [
  //                           generateStopDataForXLSX(row, 0, {
  //                             type,
  //                             route: route.index,
  //                             vehicle: route.vehicle_name,
  //                             driver: route.driver
  //                               ? `${route.driver.first_name} ${route.driver.last_name}`
  //                               : "",

  //                             stop: count
  //                           })
  //                         ]
  //                       : row.units.map((unit, i) =>
  //                           generateStopDataForXLSX(row, i, {
  //                             type,
  //                             route: route.index,
  //                             vehicle: route.vehicle_name,
  //                             driver: route.driver
  //                               ? `${route.driver.first_name} ${route.driver.last_name}`
  //                               : "",

  //                             stop: count
  //                           })
  //                         ))
  //                   ];
  //                 }, [])
  //             ]
  //           : array;
  //       }, [])
  //     ];
  //   } else {
  //     data = [
  //       headerRow,
  //       ...project.vrp.stops
  //         .filter(
  //           task =>
  //             !["start", "end", "break"].includes(task.type) &&
  //             !isEmptyObj(task)
  //         )
  //         .reduce((array, row) => {
  //           return [
  //             ...array,
  //             ...(!row.units || row.units.length === 0
  //               ? [generateStopDataForXLSX(row, 0)]
  //               : row.units.map((unit, i) => generateStopDataForXLSX(row, i)))
  //           ];
  //         }, [])
  //     ];
  //   }

  //   if (type === "solution") {
  //     mixpanelWrapper.track("Solution Download", {
  //       "Project ID": project.id,
  //       Stops: data.length - 1,
  //       Vehicles: solution.routes.length
  //     });
  //   }

  //   exportToXlsx(
  //     type === "stops" ? "project_stops.xlsx" : "project_solution.xlsx",
  //     data
  //   );
  //   handleMenuClose();
  // };

  const openConfirmDialog = () => {
    setDeleteOpen(true);
    handleMenuClose();
  };

  const unlockedRoutes = solution
    ? solution.routes.filter(route => {
        return !route.locked;
      })
    : [];

  // is there any routes which are not locked and have stops
  const unlockedNonEmptyRoutesLength = unlockedRoutes.length
    ? unlockedRoutes.filter(route => {
        return route.stops.length > 2;
      }).length
    : 0;

  // is there any unassigned stops
  const hasUnassigned = solution
    ? solution.unassigned.stops.some(el => el.id)
    : false;

  const disableOptimize = {
    disabled: false,
    reason: ""
  };

  // Check there has stops
  const hasAddedStops = !!stops.some(stop => stop.id);
  if (!hasAddedStops) {
    disableOptimize.disabled = true;
    disableOptimize.reason = "You need to add some stops";
  } else if (
    productTour.isTourStepId(
      PRODUCT_TOUR_STEP_IDS.PART_ADDING_STOPS_AND_OPTIMIZE_STEP_SEARCH_AND_OPTIMIZE
    ) &&
    stops.length < 2
  ) {
    disableOptimize.disabled = true;
    disableOptimize.reason = "You need to add two stops";
  } else {
    // Check there are added vehicles for routes
    const hasAddedVehicles = selectedVehicles?.length > 0;
    if (!hasAddedVehicles || isPastProject) {
      disableOptimize.disabled = true;
      disableOptimize.reason = "You need to enable at least 1 vehicle";
    }
  }

  // Check there are added vehicles for routes
  const hasAddedVehicles = selectedVehicles?.length > 0;
  if (!hasAddedVehicles || isPastProject) {
    disableOptimize.disabled = true;
    disableOptimize.reason = "You need to enable at least 1 vehicle";
  }

  let disableFullReoptimize = {
    disabled: false,
    // default tooltip value
    reason: ""
  };

  if (!stops.some(el => el.id)) {
    // when we have no stops
    disableFullReoptimize.disabled = true;
    disableFullReoptimize.reason = "You need to add some stops";
  }
  // else if (!selectedVehicles.length) {
  //   // OR when we have no vehicles
  //   disableFullReoptimize.disabled = true;
  // }
  else if (
    unlockedRoutes.length === 0 ||
    selectedVehicles.length < 1 ||
    vehicles.length < 1
  ) {
    // OR when all routes/vehicles are locked
    disableFullReoptimize.disabled = true;
    disableFullReoptimize.reason =
      "You need to enable at least 1 vehicle or unlock a route";
  } else if (unlockedNonEmptyRoutesLength === 0 && !hasUnassigned) {
    // OR when we only have unlocked empty routes and we dont have unassigned stops
    disableFullReoptimize.disabled = true;
  } else if (
    !plan.ft_adjust_live_routes &&
    solution &&
    solution.routes.some(route => route.status === "in_progress")
  ) {
    // OR when route is in progress and user not allowed to make changes
    disableFullReoptimize.disabled = true;
    disableFullReoptimize.reason =
      "You can not reoptimize, as one of the routes is in progress.";
  }

  // Optimize (no solution)
  const handleOptimize = (e, acceptedChanges = false) => {
    if ((!saveDisabled || !settingsSaveDisabled) && !acceptedChanges) {
      setChangesDialog({
        visible: true,
        type: "saveDisabled",
        action: "optimize"
      });
    } else {
      if (!stops.some(el => el.id)) {
        setProjectTabValue(0);
      } else if (!vehicles.length) {
        setProjectTabValue(2);
      } else
        postOptimize("Optimize", (error, solutionData) => {
          if (
            productTour.hasActiveTourCurrently() &&
            solutionData.status !== "IN_PROGRESS" &&
            solutionData.status !== "WAITING_IN_QUEUE" &&
            (error !== undefined ||
              solutionData.status === "ERROR" ||
              !solutionData.routes)
          ) {
            productTour.cancelTour();
          }
        });
    }
  };

  // Reoptimize all
  const unassignedStopsCount = solution?.unassigned?.stops.length;

  const handleReoptimize = (e, acceptedChanges = false) => {
    if ((!saveDisabled || !settingsSaveDisabled) && !acceptedChanges) {
      setChangesDialog({
        visible: true,
        type: "saveDisabled",
        action: "reoptimize"
      });
    } else if (
      project.published_once &&
      isEditMode &&
      !project.project_started &&
      !confirmDialog?.changesAccepted
    ) {
      setConfirmDialog({
        visible: true,
        type: "saveDisabled",
        action: "continue",
        actionType: "confirm_changes"
      });
    } else if (
      project.published_once &&
      isEditMode &&
      project.project_started
    ) {
      setConfirmDialog({
        visible: true,
        type: "saveDisabled",
        action: "reoptimize",
        actionType: "confirm_started"
      });
    } else if (unassignedStopsCount > 0) {
      setConfirmDialog({
        visible: true,
        type: "saveDisabled",
        action: "reoptimize",
        actionType: "reoptimize_unscheduled"
      });
    } else {
      postOptimize("Reoptimize full");
    }
  };

  // Reoptimize selected routes
  const handleReoptimizeSelectedRoutes = (e, acceptedChanges = false) => {
    if ((!saveDisabled || !settingsSaveDisabled) && !acceptedChanges) {
      setChangesDialog({
        visible: true,
        type: "saveDisabled",
        action: "reoptimizeRoutes"
      });
    } else {
      reoptimizeRoutes();
    }
  };

  // Publish / edit planning / change after optimize
  const changeProjectStatus = status => {
    setLoadingRoutesList(true);

    setExtendableType(null);
    setExtendableId(null);

    const setStatus = () => {
      API.patch(`v1/projects/${project.id}/status`, { status })
        .then(res => handleSuccess(res))
        .catch(error => {
          // gotResponse = true;
          setLoadingRoutesList(false);
          enqueueSnackbar("Something went wrong, couldn't publish the project");
          console.log(error);
        });
    };

    const handleSuccess = res => {
      if (status === "published") {
        solution.routes.forEach(route => {
          if (
            route.stops[0].status === "finished" &&
            route.stops[route.stops.length - 1].status !== "finished"
          ) {
            client &&
              client.send(
                JSON.stringify({
                  type: "project_publish",
                  publication_settings:
                    project.publication_settings || undefined,
                  route_id: route.id,
                  driver: route.driver ? route.driver.id : null,
                  route_info: route.stops.map(task => ({
                    id: task.id,
                    requirements: task.requirements,
                    name: task.information.recipient_name,
                    status: task.status,
                    note: task.information.notes
                  }))
                })
              );
          }
        });
      }
      gotResponse = true;
      gotSuccess = true;
      setProject({ ...res.data, status, published_once: true });
    };

    let interval;
    let gotResponse = false;
    let gotSuccess = false;
    setStatus();
    interval = setInterval(() => {
      if (!gotSuccess) {
        if (gotResponse) {
          gotResponse = false;
          setStatus();
        }
      } else {
        clearInterval(interval);
        setLoadingRoutesList(false);
      }
    }, 3000);
  };

  // Warn about unsaved changes somewhere
  const warnWindowChange = (e, acceptedChanges) => {
    if (!settingsSaveDisabled && !acceptedChanges) {
      setChangesDialog({
        visible: true,
        type: "saveDisabled",
        action: "changeWindow"
      });
    } else if (solution && solution.status === "FINISHED") {
      setCurrentWindow("Optimized");
    }
  };
  // Handle publish
  const publishProject = () => {
    let vehiclesCount = 0;
    let stopsCount = 0;
    const requirements = [];
    project.solution.routes.forEach(route => {
      vehiclesCount += 1;
      stopsCount += route.stops.length;
      if (requirements.length < 3) {
        route.stops
          .filter(task => !["start", "end", "break"].includes(task.type))
          .forEach(stop => {
            if (
              stop.requirements.age_verification &&
              !requirements.includes("Age Verification")
            ) {
              requirements.push("Age Verification");
            }
            if (
              stop.requirements.signature &&
              !requirements.includes("Signature")
            ) {
              requirements.push("Signature");
            }
            if (stop.requirements.picture && !requirements.includes("Photo")) {
              requirements.push("Photo");
            }
          });
      }
    });
    mixpanelWrapper.track("Project Publish", {
      "Project ID": project.id,
      Stops: stopsCount,
      Vehicles: vehiclesCount,
      Requirements: requirements.join(", ")
    });
    changeProjectStatus("published");

    clearChangedVehicles();
    silentlyGetSolution(project.id, () => {
      if (!project.published_once) {
        enqueueSnackbar("Project published.");
      }
    });
    handlePublishToggle(false);
    if (
      productTour.isTourStepId(
        PRODUCT_TOUR_STEP_IDS.PART_PUBLISH_AND_SHARE_STEP_PUBLISH
      )
    ) {
      productTour.goToNext();
    }
  };

  const handlePublish = () => {
    if (!saveDisabled || !settingsSaveDisabled) {
      setChangesDialog({
        visible: true,
        type: "saveDisabled",
        action: "publish"
      });
      // } else if (changedVehicles.length && project.published_once) {
      //   setChangesDialog({
      //     visible: true,
      //     type: "changedVehicles",
      //     action: "publish"
      //   });
    } else publishProject();
  };

  // Select all routes
  // const selectAllRoutes = () => {
  //   setSelectedRoutes(
  //     selectedRoutes.length === solution.routes.length
  //       ? []
  //       : solution.routes.filter(el => el.selected).map(el => el.id)
  //   );

  //   handleMenuClose();
  // };

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => setOpenPublish(false), [published]);

  useEffect(() => {
    if (solution && solution.routes) {
      let reason = "";
      const reoptimizeDisabled = selectedRoutes.some(routeId => {
        const route = solution.routes.find(route => route.id === routeId);
        if (!reason && route) {
          if (route.locked) {
            reason = "Reoptimizing locked vehicle not allowed";
          } else if (
            !plan.ft_adjust_live_routes &&
            route.status === "in_progress"
          ) {
            reason =
              "You can not reoptimize, as one of the routes is in progress.";
          }
        }
        return (
          route &&
          (route.locked ||
            (!plan.ft_adjust_live_routes && route.status === "in_progress"))
        );
      });
      setReoptimizeDisabled({ disabled: reoptimizeDisabled, reason });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRoutes, solution]);

  // Cases when we want hide bottomBar
  if (
    (selectedRoutes && selectedRoutes.length > 0) ||
    isProjectInitialLoading ||
    isPastProject ||
    isStopSearchMode ||
    isRoutesSearchMode ||
    isStopSelectMode ||
    showingRouteId !== ""
  ) {
    return <></>;
  }

  let content = "";

  if (!solution) {
    content = (
      <Box display="flex" flexWrap="wrap">
        <OptimizedTooltip title={disableOptimize.reason}>
          <Fab
            className={clsx(
              classes.optimizeBtn,
              disableOptimize.disabled && "Mui-disabled"
            )}
            style={{
              top: isOptimized ? 0 : "-81px"
            }}
            onClick={e => {
              if (!disableOptimize.disabled) {
                if (
                  productTour.isTourStepId(
                    PRODUCT_TOUR_STEP_IDS.PART_ADDING_STOPS_AND_OPTIMIZE_STEP_SEARCH_AND_OPTIMIZE
                  )
                ) {
                  productTour.hidePulsingBorder();
                  productTour.goToNext();
                }
                handleOptimize(e);
              }
            }}
            ref={publishBtnRef}
            variant="extended"
            color="primary"
            data-cy="optimizeBtn"
            // disabled={disableOptimize}
            id="project_drawer_optimize_routes_button"
          >
            <MagicIcon className={classes.buttonIcon} />
            <span style={{ fontSize: 15 }}>Optimize routes</span>
          </Fab>
        </OptimizedTooltip>
      </Box>
    );
  }

  if (solution) {
    //All routes count
    const allRoutesCount = solution.routes.filter(
      route => route.stops.length > 2
    ).length;

    const getHintMessage = () => {
      if (!published) {
        if (!project.published_once) {
          return unassignedRoutesCount === allRoutesCount
            ? "Assign drivers to your route."
            : unassignedRoutesCount > 0
            ? `${unassignedRoutesCount} route${
                unassignedRoutesCount > 1 ? "s are" : " is"
              } unassigned.`
            : "All routes are assigned.";
        } else {
          return "Auto-saving all changes";
        }
      }
      return "";
    };

    content = !isPastProject ? (
      <Box display="flex" flexWrap="wrap">
        {!published && (
          <OptimizedTooltip
            placement="top"
            title={disableFullReoptimize.reason}
          >
            <Fab
              className={clsx(
                classes.reoptimizeBtn,
                disableFullReoptimize.disabled && "Mui-disabled",
                //When we have not routes we hide bottom bar and reoptimize btn postition is changed
                allRoutesCount < 1 &&
                  !project.published_once &&
                  classes.reoptimizeBtnWithoutBottomBar
              )}
              onClick={() =>
                !disableFullReoptimize.disabled && handleReoptimize()
              }
              data-cy="reoptimizeFull"
              color="primary"
              size="large"
            >
              <MagicIcon color="primary" className={classes.buttonIcon} />
              <Typography variant="p" component="span" style={{ fontSize: 15 }}>
                Reoptimize routes
              </Typography>
            </Fab>
          </OptimizedTooltip>
        )}
        {(allRoutesCount > 0 || project.published_once) && (
          <Grid container className={classes.bottomBarContainer} wrap="nowrap">
            <Grid
              item
              className={clsx(classes.bottomBarLeftSide)}
              xs
              container
              alignItems="center"
            >
              {getHintMessage() !== "" ? (
                <>
                  <Grid item style={{ marginRight: 12, display: "flex" }}>
                    <InfoOutlinedIcon />
                  </Grid>
                  <Grid item>
                    <Typography variant="p" component="p" color="secondary">
                      {getHintMessage()}
                    </Typography>
                  </Grid>
                </>
              ) : (
                " "
              )}
            </Grid>
            <Grid item>
              {(published || (!published && project.published_once)) && (
                <>
                  <ButtonGroup
                    className={
                      classes.publishedAndDriverConfigurationButtonsGroup
                    }
                    id="project_drawer_edit_mode_button"
                  >
                    <Box className={classes.editModeSwitch}>
                      <Typography variant="p">Edit mode</Typography>
                      <Switch
                        color="primary"
                        checked={!published && project.published_once}
                        className={classes.editModeToggle}
                        onClick={() =>
                          published
                            ? changeProjectStatus("optimized")
                            : handlePublish()
                        }
                        variant="outlined"
                        disabled={isPastProject}
                      />
                    </Box>
                    <Button
                      className={classes.driverAppConfigurationInEditMode}
                      style={openPublish ? { backgroundColor: "#fff" } : {}}
                    >
                      <OptimizedTooltip
                        placement="top"
                        title="Driver app settings"
                      >
                        <Box ml={"auto"} mr={1}>
                          <IconButton
                            onClick={() => handlePublishToggle(!openPublish)}
                            disabled={productTour.isTourStepId(
                              PRODUCT_TOUR_STEP_IDS.PART_PUBLISH_AND_SHARE_STEP_PUBLISH
                            )}
                          >
                            <ArrowDropDownIcon />
                          </IconButton>
                        </Box>
                      </OptimizedTooltip>
                    </Button>
                  </ButtonGroup>
                </>
              )}
              {!published && !project.published_once && (
                <>
                  <ButtonGroup
                    className={
                      classes.publishedAndDriverConfigurationButtonsGroup
                    }
                    id="project_drawer_publish_button"
                  >
                    <Button
                      disabled={publishDisabled}
                      onClick={() => {
                        handlePublish();
                      }}
                      data-cy="publishBtn"
                      className={classes.publishBtn}
                    >
                      {/* <PublishIcon /> */} Publish routes
                    </Button>
                    {/* Driver app settings*/}
                    <Button
                      className={classes.driverAppConfiguration}
                      style={openPublish ? { backgroundColor: "#0114CB" } : {}}
                    >
                      <OptimizedTooltip
                        placement="top"
                        title="Driver app settings"
                      >
                        <Box ml={"auto"} mr={1}>
                          <IconButton
                            onClick={() => handlePublishToggle(!openPublish)}
                            disabled={productTour.isTourStepId(
                              PRODUCT_TOUR_STEP_IDS.PART_PUBLISH_AND_SHARE_STEP_PUBLISH
                            )}
                          >
                            <ArrowDropDownIcon />
                          </IconButton>
                        </Box>
                      </OptimizedTooltip>
                    </Button>
                  </ButtonGroup>
                </>
              )}
            </Grid>
          </Grid>
        )}
      </Box>
    ) : (
      ""
    );
  }

  return (
    <div className={clsx(classes.wrapper, solution && classes.wrapperExpanded)}>
      {content}
      {confirmDialog && (
        <ConfirmDialog
          open={confirmDialog.visible}
          handleClose={() =>
            setConfirmDialog({
              ...confirmDialog,
              visible: false
            })
          }
          action={(e, dialogState) => {
            if (confirmDialog?.actionType === "reoptimize_unscheduled") {
              if (!isProjectStarted) {
                dialogState.checked
                  ? //Reoptimize by default settings
                    postOptimize()
                  : //Reoptimize without unschedulet stops
                    postOptimize("not_optimize_unassigned_stops");
              } else {
                dialogState.selectedValue ===
                "reoptimize_routes_that_have_not_started"
                  ? dialogState.checked
                    ? postOptimize() //Default optimize (optimize default settings you can see inside postOptimize function)
                    : postOptimize("not_optimize_unassigned_stops")
                  : dialogState.checked
                  ? // Optimize all stops that have started and unscheduled
                    postOptimize("reopimize_full")
                  : // Optimize all stops that have started without unscheduled
                    postOptimize("reoptimize_all_routes_without_unscheduled");
              }
            }
            if (confirmDialog?.actionType === "confirm_changes") {
              if (unassignedStopsCount > 0) {
                Promise.resolve().then(res => {
                  setConfirmDialog({
                    visible: true,
                    type: "saveDisabled",
                    action: "reoptimize",
                    actionType: "reoptimize_unscheduled"
                  });
                });
              } else {
                postOptimize();
              }
            }
            if (confirmDialog?.actionType === "confirm_started") {
              if (unassignedStopsCount > 0) {
                Promise.resolve().then(res => {
                  setConfirmDialog({
                    visible: true,
                    type: "saveDisabled",
                    action: "reoptimize",
                    actionType: "reoptimize_unscheduled"
                  });
                });
              } else {
                if (
                  dialogState?.selectedValue ===
                  "reoptimize_routes_that_have_not_started"
                )
                  postOptimize();
                //Reopitimze all routes that have started their route
                else postOptimize("reoptimize_all_routes");
              }
            }
          }}
          title={
            confirmDialog?.actionType?.includes("confirm")
              ? "Are you sure you want to reoptimize your routes?"
              : "You have unscheduled stops in your project"
          }
          body={
            <>
              <Typography variant="p">
                {/* If our modal is confirm type just we need to show information message about changes if it is not we need to inform about action that will happen when user clicks the confirm button */}
                {confirmDialog?.actionType?.includes("confirm")
                  ? "Routes that are locked will not be affected, but all other routes may change. This action cannot be reversed, your drivers' routes will update immediately."
                  : `Do you want to try to plan ${unassignedStopsCount} unscheduled stop${
                      unassignedStopsCount > 1 ? "s" : ""
                    } in your routes?`}
              </Typography>
            </>
          }
          confirmText={
            confirmDialog?.actionType?.includes("confirm")
              ? unassignedStopsCount > 0
                ? "Continue"
                : "Reoptimize"
              : capitalize(confirmDialog?.action)
          }
          modalType={
            confirmDialog?.actionType === "confirm_changes"
              ? "withText"
              : confirmDialog?.actionType === "confirm_started"
              ? "withRadioGroup"
              : confirmDialog?.actionType === "reoptimize_unscheduled"
              ? "withCheckbox"
              : ""
          }
        />
      )}
      {solution && (
        <Popper
          open={openPublish}
          anchorEl={publishBtnRef.current}
          transition
          disablePortal
          placement="top-start"
          className={classes.publishPopper}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: "right bottom"
              }}
            >
              <Paper className={classes.publishPaper}>
                <ClickAwayListener onClickAway={handlePublishClose}>
                  <Box>
                    <PublishSettings />
                  </Box>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </div>
  );

  // return (
  //   <Box
  //     className={classes.root}
  //     position="relative"
  //     display="flex"
  //     justifyContent="center"
  //   >
  //     {/* Reoptimize FAB */}
  //     {solution &&
  //       currentWindow === "Optimized" &&
  //       !selectedRoutes.length &&
  //       !project.published_once &&
  //       !published && (
  //         <OptimizedTooltip
  //           placement="bottom"
  //           title={
  //             disableFullReoptimize.disabled
  //               ? disableFullReoptimize.reason
  //               : "Reoptimize"
  //           }
  //         >
  //           <div className={classes.fabWrapper}>
  //             <Fab
  //               className={classes.fab}
  //               onClick={handleReoptimize}
  //               disabled={disableFullReoptimize.disabled}
  //               data-cy="reoptimizeFull"
  //             >
  //               <MagicIcon color="primary" /> Reoptimize Routes
  //             </Fab>
  //           </div>
  //         </OptimizedTooltip>
  //       )}
  //     <Box
  //       component={Paper}
  //       className={clsx(classes.paper, {
  //         [classes.cutoutClipPath]:
  //           solution &&
  //           currentWindow === "Optimized" &&
  //           !selectedRoutes.length &&
  //           !project.published_once &&
  //           !published
  //       })}
  //       width="100%"
  //       px={2}
  //       py={selectedRoutes.length ? 1.75 : 1.5}
  //     >
  //       <Box display="flex" width="100%" alignItems="center">
  //         {solution && currentWindow === "Optimized" ? (
  //           <>
  //             {published ? (
  //               <Button
  //                 className={clsx(
  //                   classes.optimizeBtn,
  //                   classes.reoptimizeBtn,
  //                   classes.editProjectBtn
  //                 )}
  //                 onClick={() => changeProjectStatus("optimized")}
  //                 variant="outlined"
  //                 disabled={isPastProject}
  //                 // color="primary"
  //                 data-cy="editPlanningBtn"
  //               >
  //                 <EditIcon
  //                   fontSize="small"
  //                   style={{ marginLeft: remCalc(-2) }}
  //                 />
  //                 <Box ml={1}>Edit project</Box>
  //               </Button>
  //             ) : selectedRoutes.length ? (
  //               <OptimizedTooltip
  //                 placement="top"
  //                 title={
  //                   reoptimizeDisabled.disabled ? reoptimizeDisabled.reason : ""
  //                 }
  //               >
  //                 <div>
  //                   <Button
  //                     className={clsx(
  //                       classes.optimizeBtn,
  //                       classes.reoptimizeBtn
  //                     )}
  //                     onClick={handleReoptimizeSelectedRoutes}
  //                     disabled={reoptimizeDisabled.disabled}
  //                     variant="outlined"
  //                     color="primary"
  //                     data-cy="reoptimizeBtn"
  //                   >
  //                     <MagicIcon className={classes.buttonIcon} /> Reoptimize
  //                   </Button>
  //                 </div>
  //               </OptimizedTooltip>
  //             ) : (
  //               <>
  //                 {/* Publish */}
  //                 <ButtonGroup
  //                   variant="contained"
  //                   color="primary"
  //                   ref={publishBtnRef}
  //                   aria-label="split button"
  //                   className={classes.btnGroup}
  //                 >
  //                   {project.published_once ? (
  //                     <Button
  //                       className={clsx(
  //                         classes.optimizeBtn,
  //                         classes.reoptimizeBtn,
  //                         classes.editProjectBtn
  //                       )}
  //                       onClick={() => handlePublish()}
  //                       variant="outlined"
  //                       disabled={isPastProject}
  //                       // color="primary"
  //                       data-cy="editPlanningBtn"
  //                     >
  //                       <Box mr={1}>Back to view mode</Box>
  //                       <ChevronRightIcon
  //                         fontSize="small"
  //                         style={{ marginLeft: remCalc(-2) }}
  //                       />
  //                     </Button>
  //                   ) : (
  //                     <OptimizedTooltip title="Publish changes" placement="top">
  //                       <Button
  //                         className={classes.optimizeBtn}
  //                         disabled={publishDisabled}
  //                         onClick={() => {
  //                           handlePublish();
  //                         }}
  //                         data-cy="publishBtn"
  //                         id="project_drawer_publish_button"
  //                       >
  //                         Publish project
  //                       </Button>
  //                     </OptimizedTooltip>
  //                   )}
  //                 </ButtonGroup>
  //                 <OptimizedTooltip
  //                   placement="top"
  //                   title="Driver app configuration"
  //                 >
  //                   <Box ml={"auto"} mr={1}>
  //                     <IconButton
  //                       onClick={() => handlePublishToggle(!openPublish)}
  //                     >
  //                       <AppSettingsIcon />
  //                     </IconButton>
  //                   </Box>
  //                 </OptimizedTooltip>
  //               </>
  //             )}

  //             <Box
  //               display="flex"
  //               alignItems="center"
  //               ml={
  //                 solution &&
  //                 currentWindow === "Optimized" &&
  //                 (published || selectedRoutes.length)
  //                   ? "auto"
  //                   : ""
  //               }
  //             >
  //               {selectedRoutes.length ? (
  //                 <SelectedRouteActions
  //                   classes={classes}
  //                   printRef={printRef}
  //                   hasStops={hasStops}
  //                   setPrinting={setPrinting}
  //                   readyToPrintLabel={readyToPrintLabel}
  //                   setPrintingLabel={setPrintingLabel}
  //                   labelsPrintRef={labelsPrintRef}
  //                   reoptimizeDisabled={reoptimizeDisabled}
  //                   readyToPrint={readyToPrint}
  //                   selectAllRoutes={selectAllRoutes}
  //                   handleCsvDownload={handleCsvDownload}
  //                   hasSelectedRouteStops={hasSelectedRouteStops}
  //                 />
  //               ) : (
  //                 <Box display="inline-flex" alignItems="center">
  //                   <Box className={classes.verticalDivider} mr={1} />
  //                   <MoreOptionsMenu
  //                     isOptimizedWindow
  //                     anchorEl={anchorEl}
  //                     setAnchorEl={setAnchorEl}
  //                     readyToPrintLabel={readyToPrintLabel}
  //                     setPrintingLabel={setPrintingLabel}
  //                     labelsPrintRef={labelsPrintRef}
  //                     handleMenuClick={handleMenuClick}
  //                     handleMenuClose={handleMenuClose}
  //                     handleCsvDownload={handleCsvDownload}
  //                     selectAllRoutes={selectAllRoutes}
  //                     openConfirmDialog={openConfirmDialog}
  //                     isPastProject={isPastProject}
  //                     hasStops={hasStops}
  //                     published={published}
  //                   />
  //                 </Box>
  //               )}
  //             </Box>
  //           </>
  //         ) : (
  //           <>
  //             {solution &&
  //             (solution.routes.some(route =>
  //               selectedVehicles.includes(route.vehicle_id)
  //             ) ||
  //               solution.showAll) &&
  //             project.status &&
  //             project.status.toLowerCase() !== "preparing" ? (
  //               <OptimizedTooltip
  //                 placement="top"
  //                 title={!selectedVehicles.length ? "Please add vehicles" : ""}
  //               >
  //                 <div>
  //                   <Button
  //                     className={clsx(classes.optimizeBtn)}
  //                     onClick={warnWindowChange}
  //                     variant="contained"
  //                     color="primary"
  //                     ref={publishBtnRef}
  //                     disabled={
  //                       solution.status !== "FINISHED" ||
  //                       (!solution.showAll && !selectedVehicles.length)
  //                     }
  //                     data-cy="continueBtn"
  //                   >
  //                     Go to routes{" "}
  //                     <KeyboardArrowRightIcon
  //                       className={classes.buttonIconRight}
  //                     />
  //                   </Button>
  //                 </div>
  //               </OptimizedTooltip>
  //             ) : (
  //               <OptimizedTooltip
  //                 placement="top"
  //                 title={
  //                   !stops.some(el => el.id)
  //                     ? "Please add stops"
  //                     : !vehicles.length
  //                     ? "Please add vehicles"
  //                     : ""
  //                 }
  //               >
  //                 <div
  //                   onClick={e => {
  //                     console.log("KTO TAM");
  //                     if (!selectedVehicles.length) {
  //                       let el = document.getElementById("vehicleTabHighlight");
  //                       if (el) {
  //                         el.style.animation = "none";
  //                         // eslint-disable-next-line no-unused-vars
  //                         const triggerReflow =
  //                           el.offsetHeight; /* trigger reflow */
  //                         el.style.animation =
  //                           "pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1)";
  //                       }
  //                     }
  //                   }}
  //                 >
  //                   <Button
  //                     className={clsx(classes.optimizeBtn, {
  //                       // [classes.pointerEventsEnabled]: !selectedVehicles.length
  //                     })}
  //                     onClick={e => {
  //                       handleOptimize(e);
  //                     }}
  //                     ref={publishBtnRef}
  //                     variant="contained"
  //                     color="primary"
  //                     data-cy="optimizeBtn"
  //                     disabled={disableOptimize}
  //                     id="project_drawer_optimize_routes_button"
  //                   >
  //                     <MagicIcon className={classes.buttonIcon} /> Optimize
  //                     routes
  //                   </Button>
  //                 </div>
  //               </OptimizedTooltip>
  //             )}
  //             <Box display="flex" alignItems="center" ml="auto">
  //               <Box display="inline-flex" alignItems="center">
  //                 <Box className={classes.verticalDivider} mr={1} />
  //                 <MoreOptionsMenu
  //                   anchorEl={anchorEl}
  //                   setAnchorEl={setAnchorEl}
  //                   readyToPrintLabel={readyToPrintLabel}
  //                   setPrintingLabel={setPrintingLabel}
  //                   labelsPrintRef={labelsPrintRef}
  //                   handleMenuClick={handleMenuClick}
  //                   handleMenuClose={handleMenuClose}
  //                   handleCsvDownload={handleCsvDownload}
  //                   selectAllRoutes={selectAllRoutes}
  //                   openConfirmDialog={openConfirmDialog}
  //                   isPastProject={isPastProject}
  //                   hasStops={hasStops}
  //                   published={published}
  //                 />
  //               </Box>
  //             </Box>
  //           </>
  //         )}
  //       </Box>
  //     </Box>

  //     <Box display="none">
  //       <Box ref={printRef}>
  //         {solution && isPrinting && (
  //           <PrintRoutes
  //             routes={solution.routes}
  //             selectedRoutes={selectedRoutes}
  //             projectName={project.name}
  //           />
  //         )}
  //       </Box>
  //     </Box>

  //     <Box display="none">
  //       <Box ref={labelsPrintRef}>
  //         {solution && isPrintingLabel && (
  //           <PrintLabels
  //             solution={solution}
  //             selectedRoutes={selectedRoutes}
  //             billingDetails={billingDetails}
  //             organisation={organisation}
  //           />
  //         )}
  //       </Box>
  //     </Box>

  //     {/* Dialogs */}
  //     <ConfirmDialog
  //       open={deleteOpen}
  //       handleClose={() => setDeleteOpen(false)}
  //       action={deleteAllStops}
  //       title={"Delete all stops?"}
  //       body={"Deleting all stops is permanent and cannot be undone."}
  //     />
  //     <ShareProject open={shareOpen} handleClose={() => setShareOpen(false)} />
  //     {/* Publication settings */}
  //     <Popper
  //       open={openPublish}
  //       anchorEl={publishBtnRef.current}
  //       transition
  //       disablePortal
  //       placement="top-start"
  //       className={classes.publishPopper}
  //     >
  //       {({ TransitionProps }) => (
  //         <Grow
  //           {...TransitionProps}
  //           style={{
  //             transformOrigin: "right bottom"
  //           }}
  //         >
  //           <Paper className={classes.publishPaper}>
  //             <ClickAwayListener onClickAway={handlePublishClose}>
  //               <Box>
  //                 <PublishSettings />
  //               </Box>
  //             </ClickAwayListener>
  //           </Paper>
  //         </Grow>
  //       )}
  //     </Popper>
  //     {/* Publish confirmation */}
  //     <UnsavedChangesDialog
  //       open={changesDialog.visible}
  //       action={e => {
  //         switch (changesDialog.action) {
  //           case "optimize":
  //             handleOptimize(e, true);
  //             break;
  //           case "reoptimize":
  //             handleReoptimize(e, true);
  //             break;
  //           case "reoptimizeRoutes":
  //             handleReoptimizeSelectedRoutes(e, true);
  //             break;
  //           case "changeWindow":
  //             warnWindowChange(e, true);
  //             break;
  //           default:
  //             publishProject();
  //         }
  //       }}
  //       handleClose={() => setChangesDialog({ visible: false })}
  //       title={
  //         changesDialog.type === "changedVehicles"
  //           ? `Publish ${changedVehicles.length} ${
  //               changedVehicles.length === 1 ? "change" : "changes"
  //             }`
  //           : undefined
  //       }
  //       body={
  //         changesDialog.type === "changedVehicles"
  //           ? "By publishing these changes, all drivers which are assigned to a vehicle will be notified."
  //           : undefined
  //       }
  //       closeText={
  //         changesDialog.type === "changedVehicles" ? "Cancel" : "Keep editing"
  //       }
  //       actionText={
  //         changesDialog.type === "changedVehicles" ? "Publish" : "Discard"
  //       }
  //     />
  //   </Box>
  // );
}

function mapStateToProps(state) {
  return {
    project: state.project,
    vehicles: state.project.vehicles,
    selectedVehicles: state.project.selectedVehicles,
    stops: state.project.vrp.stops,
    solution: state.project.solution,
    published: ["published", "expired", "finished"].includes(
      state.project.status.toLowerCase()
    ),
    isPastProject:
      ["expired", "finished"].includes(state.project.status.toLowerCase()) ||
      (state.project.solution?.routes.length &&
        state.project.solution?.routes.every(
          route => route?.stops[route?.stops?.length - 1].status === "finished"
        )),
    hasStops: state.project.vrp.stops.some(
      task =>
        task.type !== "start" &&
        task.type !== "end" &&
        !isEmptyObj(task) &&
        task.type !== "break"
    ),
    hasSelectedRouteStops: state.project.solution?.routes
      .filter(route => state.common.selectedRoutes.includes(route?.id))
      .some(route =>
        route?.stops?.some(
          task =>
            task.type !== "start" &&
            task.type !== "end" &&
            !isEmptyObj(task) &&
            task.type !== "break"
        )
      ),
    selectedRoutes: state.common.selectedRoutes,
    lockedRoutes: state.project.lockedRoutes,
    currentWindow: state.common.currentWindow,
    organisation: state.auth.userData?.organisationSite?.organisation,
    billingDetails: state.account.billingDetails,
    changedVehicles: state.project.changedVehicles,
    saveDisabled: state.extendable.saveDisabled,
    settingsSaveDisabled: state.common.settingsSaveDisabled,
    publishDisabled: state.common.publishDisabled,
    distanceUnits: state.project.vrp.configuration.distance_units,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    isEditMode: state.project.status === "optimized",
    isProjectInitialLoading: state.loading.projectInitial,
    isStopSearchMode: state.common.isStopSearchMode,
    isStopSelectMode: state.common.isStopSelectMode,
    isRoutesSearchMode: state.common.isRoutesSearchMode,
    isProjectStarted: state.project.project_started,
    showingRouteId: state.project.showingRouteId,
    determinateLoading: state.loading.determinateLoading
  };
}

export default connect(mapStateToProps, {
  setProjectTabValue,
  setCurrentWindow,
  setExtendableType,
  setExtendableId,
  setLoadingRoutesList,
  deleteAllStops,
  setProject,
  silentlyGetSolution,
  clearChangedVehicles,
  postOptimize,
  reoptimizeRoutes,
  setSelectedRoutes
})(BottomActions);
